export default __webpack_public_path__ + "static/media/V490_SOV.ad5a0e96.pdf";